import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class ComercioExteriorPropietarioForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true
      });
    }
  }

  rules(data) {
    return {
      'NumRegIdTrib': ['required', 'string', 'min:6', 'max:40'],
      'ResidenciaFiscal': ['required', 'string', 'min:3', 'max:3'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      data: {}
    })
  }

  render() {
    const rules = this.rules();
    const { isValid, data = {} } = this.state;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número Registro ID Tributario"
              name="NumRegIdTrib"
              placeholder=""
              help=""
              minLength="6"
              maxLength="40"
              rules={ rules.NumRegIdTrib }
              value={ data.NumRegIdTrib }
              onChange={ this.handleOnChange }
            />
          </Col>
          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Residencia Fiscal"
              name="ResidenciaFiscal"
              placeholder=""
              help=""
              minLength="3"
              maxLength="3"
              rules={ rules.ResidenciaFiscal }
              value={ data.ResidenciaFiscal }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varios Propietarios usando el botón "Agregar Propietario", la lista se mostrarán en la tabla de Propietarios.
            </p>
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar Propietario
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default ComercioExteriorPropietarioForm;